import _ from 'lodash';
import * as types from '../mutation-types';
import journeyTypes from '../../api/journeyTypes';

const state = {
  selected: {
    id: null,
    name: null,
    label: null,
    icon: null,
    sort_order: null
  },
  journeyTypes: [
    {
      id: null,
      name: null,
      label: null,
      icon: null,
      sort_order: null
    }
  ]
};

const getters = {
  JourneyTypes: state => state.journeyTypes,
  SelectedJourneyType: state => state.selected
};

const actions = {
  getJourneyTypes({ commit, dispatch }) {
    journeyTypes.getJourneyTypes().then(journeyTypes => {
      commit(types.SET_JOURNEY_TYPES, journeyTypes.data);
      dispatch('selectJourneyType', journeyTypes.data[0]);
    });
  },
  selectJourneyType({ commit, dispatch }, journeyType) {
    commit(types.SET_SELECTED_JOURNEY_TYPE, journeyType);
    let journeys = _.orderBy(journeyType.journeys, ['name'], ['asc']);
    dispatch('selectJourney', journeys[0]);
  }
};

const mutations = {
  [types.SET_JOURNEY_TYPES](state, journeyTypes) {
    state.journeyTypes = journeyTypes;
  },
  [types.SET_SELECTED_JOURNEY_TYPE](state, journeyType) {
    state.selected = journeyType;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
